import { createFileRoute } from '@tanstack/react-router';
import { SpaceSettings } from '@/components/spaces/SpaceSettings.tsx';

export const Route = createFileRoute('/$spaceSlug/settings')({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: 'Findya | Space settings',
      },
    ],
  }),
});

function RouteComponent() {
  return <SpaceSettings />;
}
